// 八戸市内のレストランデータ（6軒に厳選）
export const restaurants = [
  {
    id: 1,
    name: '八食センター',
    description: '新鮮な海鮮料理が楽しめる市場',
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=800&h=600&fit=crop'
  },
  {
    id: 2,
    name: 'せんべい汁の店',
    description: '八戸名物せんべい汁専門店',
    image: 'https://images.unsplash.com/photo-1547592166-23ac45744acd?w=800&h=600&fit=crop'
  },
  {
    id: 3,
    name: '寿司処 まぐろ亭',
    description: '新鮮なお寿司と刺身',
    image: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=800&h=600&fit=crop'
  },
  {
    id: 4,
    name: 'ラーメン横丁',
    description: '八戸ラーメンの名店街',
    image: 'https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=800&h=600&fit=crop'
  },
  {
    id: 5,
    name: 'カフェ＆レストラン 港',
    description: '洋食とカフェメニュー',
    image: 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?w=800&h=600&fit=crop'
  },
  {
    id: 6,
    name: '居酒屋 漁火',
    description: '地酒と新鮮な海鮮料理',
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&h=600&fit=crop'
  }
];
